export const BUTTON_TITLE = {
  TO_BASKET: 'В корзину',
  IN_BASKET: 'В корзине',
  PRE_ORDER: 'Оформить предзаказ',
  SUBSCRIBE: 'Отправить',
};

export const PROMO_SUBSCRIBE = {
  SUCCESS: 'При поступлении товара мы уведомим вас через e-mail, который вы оставили',
  INITIAL: 'Оставьте свой e-mail, и мы уведомим вас при поступлении товара',
};

export const PROMO_CHEAPER_CAPTION = 'Нашли дешевле?';
